import { createRouter, createWebHistory } from "vue-router";
import ViewTerminals from "@/views/Terminals/ViewTerminals.vue";
import ViewRegions from "@/views/Regions/ViewRegions.vue";
import ViewModalities from "@/views/Modalities/ViewModalities.vue";
import ViewLotteries from "@/views/Lotteries/ViewLotteries.vue";
import ViewRegionsConfigs from "@/views/RegionsConfigs/ViewRegionsConfigs.vue";
import ViewSellers from "@/views/Sellers/ViewSellers.vue";
import ViewSellerBets from "@/views/Sellers/ViewSellerBets.vue";
import EntriesSeller from "@/views/Sellers/EntriesSeller.vue";
import ViewEntries from "@/views/Entries/ViewEntries.vue";
import ViewEntriesNumbers from "@/views/Entries/ViewEntriesNumbers.vue";
import ViewEntriesNumbersDetail from "@/views/Entries/ViewEntriesNumbersDetail.vue";
import ViewResults from "@/views/Results/ViewResults.vue";
import ViewFinancialTransactions from "@/views/FinancialTransactions/ViewFinancialTransactions.vue";
import ViewAccount from "@/views/Account/ViewAccount.vue";
import ViewDashboard from "@/views/Dashboard/ViewDashboard.vue";
import ViewUsers from "@/views/Users/ViewUsers.vue";
import ViewCollectors from "@/views/Collectors/ViewCollectors.vue";

import ViewCollectorCommissions from "@/views/Collectors/ViewCollectorCommissions.vue";
import ViewCollectorHistory from "@/views/Collectors/ViewCollectorHistory.vue";
import ViewCollectorCharges from "@/views/Collectors/ViewCollectorCharges.vue";
import ViewEntriesCollectors from "@/views/Collectors/ViewEntriesCollectors.vue";
import ViewSettings from "@/views/Settings/ViewSettings.vue";
import ViewApiClients from "@/views/Settings/ViewApiClients.vue";
import ViewTasks from "@/views/Tasks/ViewTasks.vue";
import ViewAppVersions from "@/views/AppVersions/ViewAppVersions.vue";
import ViewDescargasEnviada from "@/views/Descargas/ViewDescargasEnviada.vue";
import ViewDescargasRecebida from "@/views/Descargas/ViewDescargasRecebida.vue";
import ViewHistoricoDescarga from "@/views/Descargas/ViewHistoricoDescarga.vue";
import ViewBancas from "@/views/Bancas/ViewBancas.vue";
import AdminRegister from "@/views/PrivateRegister/AdminRegister.vue";
import ViewDownload from "@/views/Download/ViewDownload.vue";
import DownloadApps from "@/views/Download/download.vue";
import ViewWhatsApp from "@/views/WhatsApp/ViewWhatsApp.vue";
import ViewWhatsAppInstance from "@/views/WhatsApp/ViewWhatsAppInstance.vue";
import { hasPermission, getDefaultRoute } from "@/services/permissions";

const routes = [
  // Rota pública para download do aplicativo
  {
    path: "/download",
    name: "Download",
    component: ViewDownload,
    meta: { 
      hideFromNavigation: true,
      requiresNoAuth: true,
      isPublic: true
    }
  },
  // Rota secreta para registro de administrador - deve vir primeiro
  {
    path: "/admin-register-secret-7f8a2b9c4d5e6f1a3b8c9d2e5f7a9b4c",
    name: "AdminRegister",
    component: AdminRegister,
    meta: { 
      hideFromNavigation: true,
      requiresNoAuth: true
    }
  },
  {
    path: "/",
    redirect: () => {
      // Redirecionar baseado no role do usuário
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      return getDefaultRoute(user.role);
    }
  },
  {
    path: "/dashboard",
    component: ViewDashboard,
    beforeEnter: (to, from, next) => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      // AGENTE não pode acessar Dashboard
      if (user.role === 4) {
        next('/results');
      } else {
        next();
      }
    }
  },
  {
    path: "/terminals",
    component: ViewTerminals,
    meta: { permission: 'terminals' }
  },
  {
    path: "/bancas",
    component: ViewBancas,
    meta: { permission: 'bancas' }
  },
  {
    path: "/regions",
    component: ViewRegions,
    meta: { permission: 'regions' }
  },
  {
    path: "/modalities",
    component: ViewModalities,
    meta: { permission: 'modalities' }
  },
  {
    path: "/lotteries",
    component: ViewLotteries,
    meta: { permission: 'lotteries' }
  },
  {
    path: "/regionsconfigs",
    component: ViewRegionsConfigs,
    meta: { permission: 'regionsconfigs' }
  },
  {
    path: "/sellers",
    component: ViewSellers,
    meta: { permission: 'sellers' }
  },
  {
    path: "/sellers/bets",
    component: ViewSellerBets,
    meta: { permission: 'sellers' }
  },
  {
    path: "/sellers/entries",
    component: EntriesSeller,
    meta: { permission: 'sellers' }
  },
  {
    path: "/sellers/lottery-history",
    component: () => import("@/views/Sellers/SellerLotteryHistory.vue"),
    meta: { permission: 'sellers' }
  },
  {
    path: "/entries",
    component: ViewEntries,
    meta: { permission: 'entries' }
  },
  {
    path: "/entriesnumbers",
    component: ViewEntriesNumbers,
    meta: { permission: 'entries' }
  },
  {
    path: "/entriesnumbersdetail",
    component: ViewEntriesNumbersDetail,
    meta: { permission: 'entries' }
  },
  {
    path: "/results",
    component: ViewResults,
    meta: { permission: 'results' }
  },
  {
    path: "/descargas-enviada",
    component: ViewDescargasEnviada,
    meta: { permission: 'descargas' }
  },
  {
    path: "/descargas-recebida",
    component: ViewDescargasRecebida,
    meta: { permission: 'descargas' }
  },
  {
    path: "/historico-descarga",
    component: ViewHistoricoDescarga,
    meta: { permission: 'descargas' }
  },
  {
    path: "/financialTransactions",
    component: ViewFinancialTransactions,
    meta: { permission: 'financialtransactions' }
  },
  {
    path: "/users",
    component: ViewUsers,
    meta: { permission: 'users' }
  },
  {
    path: "/collectors",
    component: ViewCollectors,
    meta: { permission: 'collectors' }
  },

  {
    path: "/collector-commissions",
    component: ViewCollectorCommissions,
    meta: { permission: 'collectors' }
  },
  {
    path: "/collector-history",
    component: ViewCollectorHistory,
    meta: { permission: 'collectors' }
  },
  {
    path: "/collector-charges",
    component: ViewCollectorCharges,
    meta: { permission: 'collectors' }
  },
  {
    path: "/collector-entries",
    component: ViewEntriesCollectors,
    meta: { permission: 'collectors' }
  },
  {
    path: "/settings",
    component: ViewSettings,
    meta: { permission: 'settings' }
  },
  {
    path: "/api-clients",
    component: ViewApiClients,
    meta: { permission: 'settings' }
  },
  {
    path: "/tasks",
    component: ViewTasks,
    meta: { permission: 'tasks' }
  },
  {
    path: "/app-versions",
    component: ViewAppVersions,
    meta: { permission: 'appversions' }
  },
  {
    path: "/whatsapp",
    component: ViewWhatsApp,
    meta: { permission: 'notifications' }
  },
  {
    path: "/whatsconfig",
    component: ViewWhatsAppInstance,
    meta: { permission: 'settings' }
  },
  {
    path: "/account",
    component: ViewAccount,
  },
  {
    path: "/aplicativos",
    name: "Aplicativos",
    component: DownloadApps,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Guard de navegação para verificar permissões
router.beforeEach((to, from, next) => {
  // Permitir acesso direto a rotas públicas ou que não requerem autenticação
  if (to.meta && (to.meta.requiresNoAuth || to.meta.isPublic)) {
    next();
    return;
  }

  // Verificar se a rota requer permissão específica
  if (to.meta && to.meta.permission) {
    // Obter dados do usuário
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // Verificar se o usuário tem permissão
    if (user.role !== undefined && hasPermission(user.role, to.meta.permission)) {
      next(); // Permitir acesso
    } else {
      // Redirecionar para a rota padrão do usuário
      const defaultRoute = getDefaultRoute(user.role);
      if (to.path !== defaultRoute) {
        next(defaultRoute);
      } else {
        next('/dashboard'); // Fallback
      }
    }
  } else {
    // Rota sem restrição de permissão
    next();
  }
});

export default router;
